import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import BarChartGeneric from "./genericBar/BarChartGeneric";

const SellerDashboardCard = ({
  title,
  data,
  link,
  children,
  useAccordion = true,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelType, setModalType] = useState(null);
  const [isOpen, setIsOpen] = useState(true);

  const handleOpenModal = (type) => {
    setIsModalOpen(true);
    setModalType(type);
  };


  const bar1 = data[0].bar;
  const bar2 = data[1].bar;

  const cardContent = (
    <div
      className="row card-body p-0 text-center"
      style={{
        height: "100%",
        minHeight: "450px",
        width: "100%",
        margin: "auto",
      }}
    >
      <div className="col-12 col-md-12 p-2">
        <BarChartGeneric
          title={`Monthly ${title} Infringements`}
          data={bar1}
          openModel={() => handleOpenModal("bar")}
        />
      </div>

      <div className="col-12 col-md-12 p-2">
      <BarChartGeneric
          title={`Company wise ${title} Infringements`}
          data={bar2}
          openModel={() => handleOpenModal("bar")}
        />
      </div>

      {children}
    </div>
  );

  return (
    <>
      <div className="col mt-2">
        {useAccordion ? (
          <div className="card card-small mb-4">
            <div className="card-header border-bottom d-flex justify-content-between align-items-center">
              <h6
                className="my-auto"
                style={{ width: "fit-content", color: "red" }}
              >
                {title}
              </h6>

              <button
                className="btn btn-outline-light btn-sm"
                onClick={() => setIsOpen(!isOpen)}
              >
                <img
                  src={`/icons/${isOpen ? "down-arrow" : "up-arrow"}.svg`}
                  alt={isOpen ? "openIcon" : "closeIcon"}
                  width={14}
                  height={14}
                />
              </button>
            </div>

            <Collapse in={isOpen}>
              <div>{cardContent}</div>
            </Collapse>
          </div>
        ) : (
          <div className="card card-small mb-4">
            <div className="card-header border-bottom">
              <h6 className="my-auto " style={{ width: "fit-content" }}>
                <Link className="nav-link" to={link}>
                  <span style={{ color: "red" }}>{title}</span>
                </Link>
              </h6>
            </div>
            {cardContent}
          </div>
        )}
      </div>
    </>
  );
};

export default SellerDashboardCard;
